import ResponseErrorTypes from '../constants/ResponseErrorTypes';
import ResponseStatus from '../constants/ResponseStatus';

export const isSuccess = (response) => response?.responseStatus === ResponseStatus.SUCCESS;

export const isFailure = (response) => response?.responseStatus === ResponseStatus.FAILURE;

const responseHasErrorType = (response, targetErrorType) => {
    const errors = response.errors ?? [];
    return errors.some((cur) => cur.type === targetErrorType);
};

export const isSessionTokenError = (response) => {
    if (isFailure(response)) {
        return responseHasErrorType(response, ResponseErrorTypes.VEEVAID_REFRESH_TOKEN);
    }

    return false;
};

export const isExpiredSessionErrorResponse = (response) => {
    if (isFailure(response)) {
        return responseHasErrorType(response, ResponseErrorTypes.VEEVAID_INVALID_SESSION);
    }

    return false;
};
